import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {ValidEntitiesForFieldPathQuery} from 'schemas/tags/__generated/ValidEntitiesForFieldPathQuery';
import AttachDropdown from 'ui-library/attach-dropdown/AttachDropdown';
import {AttachDropdownItem} from 'ui-library/attach-dropdown/AttachDropdownConstants';
import getDefaultRenderAttachDropdownOptionInfo from 'ui-library/attach-dropdown/getDefaultRenderAttachDropdownOptionInfo';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

type ValidEntityGraphQL = NonNullable<
  NonNullable<
    ExtractByTypename<
      ValidEntitiesForFieldPathQuery['bioentity'],
      'BasicFolderItemNode'
    >['validEntitiesForFieldPathInfo']
  >['validEntities']
>[number];

export interface ValidEntitiesForFieldPathDropdownProps {
  validEntities?: Array<ValidEntityGraphQL>;
  query: string;
  onSelectOption: (id: string, name: string, url: string) => void;
}

export default function ValidEntitiesForFieldPathDropdown(
  props: ValidEntitiesForFieldPathDropdownProps
): JSX.Element {
  const dropdownRef = React.createRef<AttachDropdown>();

  const getAttachDropdownOption = (bioentity: ValidEntityGraphQL): AttachDropdownItem => ({
    item_id: bioentity.id,
    name: bioentity.name,
    item: {
      id: bioentity.id,
      iconId: bioentity.tagSchema?.iconId as BenchlingIconName | undefined,
      name: bioentity.name,
      folder: bioentity.folder,
    },
  });

  const getFilteredValidEntityOptions = (): Array<AttachDropdownItem> =>
    props.validEntities
      ? props.validEntities
          .filter((bioentity) => bioentity.name.toLowerCase().includes(props.query.toLowerCase()))
          .map((bioentity) => getAttachDropdownOption(bioentity))
      : [];

  return (
    <AttachDropdown
      ref={dropdownRef}
      query={props.query}
      getRenderOptionInfo={getDefaultRenderAttachDropdownOptionInfo}
      results={getFilteredValidEntityOptions()}
      searching={!props.validEntities}
      selectAttachment={props.onSelectOption}
      resultsRequireQuery={false}
      noResultsMessage="No valid entities exist for required path."
    />
  );
}
